import React, { useEffect, useState } from 'react';
import { Route, Routes} from 'react-router';
import Login from '../Login/Login';
import Error from '../Error/Error';
import HomePage from '../HomePage/HomePage';
import './App.scss';
import FormationPage from '../Formations/FormationPage/FormationPage';
import FormationResults from '../Formations/FormationResults/FormationResults';
import QuestionaryPage from '../Questionaries/QuestionaryPage/QuestionaryPage';
import { ToastContainer, Zoom } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';


function App() {
  const [isUserLogged, setIsUserLogged] = useState(false);
  const [activeNav, setActiveNav] = useState(false);
  const [language, setLanguage] = useState('fr');

  const username = localStorage.getItem('user');

  const toggleNavbar: () => boolean | void = () => {
    setActiveNav(!activeNav);
  }

  useEffect(() => {
    if (username) {
      setIsUserLogged(true)
    }
  }, [username])

  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
      {!isUserLogged && (
        <>
        <Routes>
          <Route path='/' element={<Login withCode={false} extrernal={false} empty={true} setIsUserLogged={false} />} />
          {/* <Route path='/login' element={<Login withCode={false} extrernal={false} empty={false} />} /> */}
          <Route path='/testInterne' element={<Login withCode={true} extrernal={false} empty={false} setIsUserLogged={setIsUserLogged} />} />
          {/* <Route path='/testExterne' element={<Login withCode={true} extrernal={true} empty={false} />} /> */}
          <Route path='/:jeton' element={<Login withCode={false} extrernal={false} empty={true} setIsUserLogged={setIsUserLogged} />} />
        </Routes>
        </>
      )}
      {isUserLogged && (
        <Routes>
          <Route path='*' element={<Error />} />
          <Route path='/' element={<HomePage username={username} language={language} setLanguage={setLanguage} activeNav={activeNav} setActiveNav={setActiveNav} toggleNavbar={toggleNavbar} />} />
          <Route path='/question/:slug' element={<FormationPage username={username} language={language} setLanguage={setLanguage} activeNav={activeNav} setActiveNav={setActiveNav} toggleNavbar={toggleNavbar} />} />
          <Route path='/formation-results' element={<FormationResults username={username} language={language} setLanguage={setLanguage} activeNav={activeNav} setActiveNav={setActiveNav} toggleNavbar={toggleNavbar} />} />
          <Route path='/questionary/:slug' element={<QuestionaryPage username={username} language={language} setLanguage={setLanguage} activeNav={activeNav} setActiveNav={setActiveNav} toggleNavbar={toggleNavbar} />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
